<template>
  <div class="my-invoice">
    <div class="section-title">我的发票</div>

    <!-- 发票列表 -->
    <div class="invoice-list">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="全部发票" name="all">
          <empty-component text="暂无发票信息哦~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="已开票" name="issued">
          <empty-component text="暂无已开具的发票~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="未开票" name="unissued">
          <empty-component text="暂无待开具的发票~"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 开票说明 -->
    <div class="invoice-tips">
      <div class="tips-title">
        <i class="el-icon-info"></i>
        开票说明
      </div>
      <div class="tips-content">
        <p>1. 发票金额为实际支付金额（不含优惠券等优惠金额）</p>
        <p>2. 发票将在订单完成后7个工作日内开具</p>
        <p>3. 增值税专用发票请在订单完成前联系客服</p>
        <p>4. 如有疑问，请联系客服4001069667</p>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyInvoice',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'all'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-invoice {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .invoice-list {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }

  .invoice-tips {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    .tips-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
      display: flex;
      align-items: center;

      i {
        color: #409eff;
        margin-right: 5px;
        font-size: 18px;
      }
    }

    .tips-content {
      color: #666;
      font-size: 14px;
      line-height: 1.8;

      p {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
